export const statusLabel = (status) => ({
  ACTIVE: '啟用',
  DISABLED: '停用',
}[status] || status || '-');

export const roleLabel = (role) => ({
  ADMIN: '管理員',
  USER: '一般使用者',
  MODERATOR: '版主',
  SE: 'SE',
  PERSON: 'person',
}[role] || role || '-');

export const tagTypeLabel = (type) => ({
  SYSTEM: '系統標籤',
  USER_DEFINED: '使用者自訂',
}[type] || type || '-');

export const menuActionLabel = (type) => ({
  LINK: '連結',
  IFRAME: '嵌入頁面',
  SUBMENU: '子選單',
}[type] || type || '-');
